import React from 'react'

import { Routes, Route } from 'react-router-dom'

import RoomList from './List'
import RoomView from './View'

const RoomsRouter = () => (
  <Routes>
    <Route path="/" element={<RoomList />} />
    <Route path=":fkey/*" element={<RoomView />} />
  </Routes>
)

RoomsRouter.displayName = 'RoomsRouter'

export default RoomsRouter
